export default defineI18nConfig(() => ({
  fallbackLocale: 'se-en',
  dateTimeFormats: {
    // Every locale can have different formats (e.g. three-letters months for ES)
    // @see https://kazupon.github.io/vue-i18n/guide/datetime.html
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
      },
    },
  },

  missingWarn: true,
  fallbackWarn: true,
  warnHtmlMessage: true,
  silentFallbackWarn: false,
  silentTranslationWarn: false,
}))
